










































import {Component, Prop, Vue} from "vue-property-decorator";
import {PropType} from "vue";
import moment from "moment";
import {IPraxisRoute, IPraxisSummary} from "@/interfaces/Student/IKiPilotPraxis";

@Component
export default class KiPilotPraxisRouteDetails extends Vue {
  @Prop({type: Object as PropType<IPraxisRoute>, default: null})
  public selectedRoute!: IPraxisRoute | null;

  @Prop({type: Object as PropType<IPraxisSummary>, default: null})
  public summary!: IPraxisSummary | null;

  public get distanceKm(): string {
    const meters = this.selectedRoute ? this.selectedRoute.distanceInMeters : this.summary?.totalDistanceInMeters;
    return meters ? (meters / 1000).toFixed(1).replace(".", ",") : "0,0";
  }

  public get durationFormatted(): string {
    const seconds = this.selectedRoute ? this.selectedRoute.durationInSeconds : this.summary?.totalTimeInSeconds;
    if (!seconds) return "00:00";
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }

  public get avgSpeed(): string {
    const kmh = this.selectedRoute ? this.selectedRoute.avgKMH : this.summary?.avgKMH;
    return kmh ? `${kmh.toFixed(1).replace(".", ",")} km/h` : "-";
  }

  public formatDate(date?: string): string {
    return date ? moment(date).format("DD.MM.YYYY") : "";
  }
}
